module.exports = __webpack_public_path__ + "assets/clone.7c5060fc.svg";